import { cn } from '../../lib/utils';

interface GenogramShapePreviewProps {
  shapeType: 'male' | 'female' | 'unknown' | 'deceased-male' | 'deceased-female' | 'deceased-unknown' | 'non-binary' | 'pregnancy' |
    'transgender-male' | 'transgender-female' | 'index-person' | 'pregnant' |
    'gay' | 'lesbian' | 'bisexual-male' | 'bisexual-female' |
    'stillbirth-male' | 'stillbirth-female' | 'institution' | 'pet' |
    'agender' | 'agender-classic' | 'two-spirit' | 'epicene' | 'epicene-classic' |
    'gender-fluid' | 'gender-fluid-classic' | 'transgender-classic' | 'transgender-alt' | 'genderqueer' |
    'bigender' | 'trigender' | 'trigender-equal' | 'pangender' | 'xenogender' |
    'travesti' | 'third-gender' | 'hijra' | 'neurogender' | 'androgyne' |
    'detragender' | 'centrgender' | 'isogender' | 'ultergender' | 'ultergender-equal' |
    'questioning' | 'queer' | 'polyamorous' | 'self-partnering' |
    'nonamorous' | 'ambiamorous' | 'polyflexible' | 'monoflexible' |
    'male-equal' | 'female-equal' |
    'demigender' | 'demiboy' | 'demigirl' | 'intergender' | 'intersex' |
    'classic-female' | 'classic-male' | 'culture-male' | 'culture-female' | 'immigration-male' | 'immigration-female';
  size?: number;
  className?: string;
}

export const GenogramShapePreview = ({
  shapeType,
  size = 48,
  className = ''
}: GenogramShapePreviewProps) => {
  const strokeWidth = 2;
  const crossStrokeWidth = 1.5;
  const strokeClass = cn(
    'text-slate-600 dark:text-slate-200 group-hover:text-slate-900 group-hover:dark:text-slate-50 transition-colors duration-150',
    className
  );

  switch (shapeType) {
    case 'male':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <rect
            x={strokeWidth}
            y={strokeWidth}
            width={32 - strokeWidth * 2}
            height={32 - strokeWidth * 2}
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        </svg>
      );

    case 'female':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle
            cx={16}
            cy={16}
            r={16 - strokeWidth}
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        </svg>
      );

    case 'unknown':
    case 'non-binary':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path
            d="M 16 2 L 30 16 L 16 30 L 2 16 Z"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        </svg>
      );

    case 'deceased-male':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <rect x={strokeWidth} y={strokeWidth} width={32 - strokeWidth * 2} height={32 - strokeWidth * 2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={-3} y1={-3} x2={35} y2={35} stroke="currentColor" strokeWidth={crossStrokeWidth} />
          <line x1={35} y1={-3} x2={-3} y2={35} stroke="currentColor" strokeWidth={crossStrokeWidth} />
        </svg>
      );

    case 'deceased-female':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={16 - strokeWidth} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={2} y1={2} x2={30} y2={30} stroke="currentColor" strokeWidth={crossStrokeWidth} />
          <line x1={30} y1={2} x2={2} y2={30} stroke="currentColor" strokeWidth={crossStrokeWidth} />

        </svg>
      );

    case 'deceased-unknown':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path d="M 16 2 L 30 16 L 16 30 L 2 16 Z" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={3} y1={3} x2={29} y2={29} stroke="currentColor" strokeWidth={crossStrokeWidth} />
          <line x1={29} y1={3} x2={3} y2={29} stroke="currentColor" strokeWidth={crossStrokeWidth} />
        </svg>
      );

    case 'pregnancy':
    case 'pregnant':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path
            d="M 16 4 L 28 26 L 4 26 Z"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        </svg>
      );

    case 'transgender-male':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <rect x={strokeWidth} y={strokeWidth} width={32 - strokeWidth * 2} height={32 - strokeWidth * 2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <circle cx={16} cy={16} r={14} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'transgender-female':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={16 - strokeWidth} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <rect x={7} y={7} width={18} height={18} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'index-person':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
        <rect x={0} y={0} width={32} height={32} fill="none" stroke="currentColor" strokeWidth={strokeWidth * 2}/>
        <rect x={32 * 0.15} y={32 * 0.15} width={32 * 0.7} height={32 * 0.7} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'gay':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <rect x={strokeWidth} y={strokeWidth} width={32 - strokeWidth * 2} height={32 - strokeWidth * 2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 8 8 L 24 8 L 16 24 Z" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'lesbian':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={16 - strokeWidth} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 8 9 L 24 9 L 16 24 Z" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'bisexual-male':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <rect x={strokeWidth} y={strokeWidth} width={32 - strokeWidth * 2} height={32 - strokeWidth * 2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 8 8 L 24 8 L 16 24 Z" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeDasharray="6,4" />
        </svg>
      );

    case 'bisexual-female':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={16 - strokeWidth} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 8 9 L 24 9 L 16 24 Z" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeDasharray="6,4" />
        </svg>
      );

    case 'stillbirth-male':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <rect x={strokeWidth} y={strokeWidth} width={32 - strokeWidth * 2} height={32 - strokeWidth * 2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={6} y1={6} x2={26} y2={26} stroke="currentColor" strokeWidth={strokeWidth * 1} />
          <line x1={26} y1={6} x2={6} y2={26} stroke="currentColor" strokeWidth={strokeWidth * 1} />

        </svg>
      );

    case 'stillbirth-female':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={16 - strokeWidth} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={6} y1={6} x2={26} y2={26} stroke="currentColor" strokeWidth={strokeWidth * 1} />
          <line x1={26} y1={6} x2={6} y2={26} stroke="currentColor" strokeWidth={strokeWidth * 1} />
        </svg>
      );

    case 'institution':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path d="M 6 28 L 6 16 L 16 6 L 26 16 L 26 28 Z" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'pet':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path d="M 16 2 L 30 16 L 16 30 L 2 16 Z" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );


      // gender based
    case 'agender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 36" className={strokeClass}>
          <circle cx={16} cy={18} r={10} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={0} x2={16} y2={9} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={6} y1={18} x2={26} y2={18} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'agender-classic':
      return (
        <svg width={size} height={size} viewBox="0 0 32 36" className={strokeClass}>
          <circle cx={16} cy={20} r={10} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={1} x2={16} y2={10} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'two-spirit':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={9} r={7} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <circle cx={16} cy={23} r={7} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={2} y1={23} x2={10} y2={23} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23} y1={9} x2={30} y2={9} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'epicene':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <circle cx={16} cy={16} r={2.75} fill="currentColor" />
          <line x1={16} y1={5} x2={16} y2={27} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={1} y1={16} x2={5} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31} y1={16} x2={27} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 5 5 A 16.5 16.5 0 0 1 27 5" fill="none" stroke="currentColor" strokeWidth={strokeWidth} transform="rotate(-47 16 16)" />
          <path d="M 27 27 A 16.5 16.5 0 0 1 5 27" fill="none" stroke="currentColor" strokeWidth={strokeWidth} transform="rotate(-47 16 16)" />
        </svg>
      );

    case 'epicene-classic':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <circle cx={16} cy={16} r={3.85} fill="currentColor" />
          <line x1={27} y1={14.4} x2={34.8} y2={8.8} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={5} y1={17.6} x2={-2.8} y2={23.2} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'gender-fluid':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={8.3} y1={8.3} x2={0.82} y2={0.82} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.82} y1={0.82} x2={6.42} y2={0.62} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.82} y1={0.82} x2={0.62} y2={6.42} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={24} y1={24} x2={30} y2={30} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={30} y1={22} x2={22} y2={30} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={27} y1={13.8} x2={30.3} y2={8.3} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={5} y1={18.2} x2={1.7} y2={23.7} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'gender-fluid-classic':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
          <circle cx={16} cy={11.6} r={8.25} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 18.64 23.92 C 21.94 25.12, 19.96 27.65, 17.32 28.98" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 16 19.85 C 13.36 21.28, 15.34 23.98, 18.64 23.14" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={17.1} y1={29.64} x2={20.4} y2={29.64} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={17.1} y1={29.64} x2={17.1} y2={26.34} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'androgyne':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={8.3} y1={8.3} x2={0.82} y2={0.82} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.82} y1={0.82} x2={6.42} y2={0.62} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.82} y1={0.82} x2={0.62} y2={6.42} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={2.8} y1={8.3} x2={8.3} y2={2.8} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'transgender-classic':
      return (
        <svg width={size} height={size} viewBox="0 0 32 34" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.7} y1={8.3} x2={31.4} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={25} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={31.4} y2={6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.6} y1={30.3} x2={20.4} y2={30.3} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={-1.05} y1={2.8} x2={6.65} y2={2.8} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={2.8} y1={-1.05} x2={2.8} y2={6.65} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={3.075} y1={3.075} x2={8.025} y2={8.025} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'transgender-alt':
      return (
        <svg width={size} height={size} viewBox="0 0 32 34" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.7} y1={8.3} x2={31.4} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={26} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={31.4} y2={6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={28.7} y2={3.3} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.6} y1={30.3} x2={20.4} y2={30.3} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={8.3} y1={8.3} x2={0.6} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.82} y1={0.82} x2={6.42} y2={0.62} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.82} y1={0.82} x2={0.62} y2={6.42} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={2.8} y1={8.3} x2={8.3} y2={2.8} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'genderqueer':
      return (
        <svg width={size} height={size} viewBox="0 0 40 20" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={5} x2={16} y2={-4.16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.64} y1={-7.04} x2={19.36} y2={-1.28} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.64} y1={-1.28} x2={19.36} y2={-7.04} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'bigender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.7} y1={8.3} x2={31.4} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={26} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={31.4} y2={6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.6} y1={30.3} x2={20.4} y2={30.3} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'trigender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.7} y1={8.3} x2={31.4} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={28} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.4} y1={0.6} x2={31.4} y2={4} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.6} y1={30.3} x2={20.4} y2={30.3} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={8.3} y1={8.3} x2={0.6} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.6} y1={0.6} x2={4} y2={0.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.6} y1={0.6} x2={0.6} y2={4} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={2.8} y1={8.3} x2={8.3} y2={2.8} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'trigender-equal':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={16} x2={27.2} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={4.8} x2={16} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.84} y1={8.16} x2={31.68} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={27.2} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={31.68} y2={4.8} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27.2} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.52} y1={30.56} x2={20.48} y2={30.56} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={8.16} y1={8.16} x2={0.32} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.32} y1={0.32} x2={4.8} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.32} y1={0.32} x2={0.32} y2={4.8} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={6.24} y1={6.24} x2={2.88} y2={9.6} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'pangender':
      return (
        <svg width={size} height={size} viewBox="0 -10 32 45" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={16} x2={27.2} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27.2} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.08} y1={31.12} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={19.92} y1={31.12} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.36} y1={30.56} x2={20.64} y2={30.56} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={4.8} x2={16} y2={-4.16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.64} y1={-7.04} x2={19.36} y2={-1.28} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.64} y1={-1.28} x2={19.36} y2={-7.04} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'xenogender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={16} r={11} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 9.28 33.6 C 12.64 29.68, 13.36 29.68, 16 33.6" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path d="M 16 33.6 C 18.64 29.68, 19.36 29.68, 22.72 33.6" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'travesti':
      return (
        <svg width={size} height={size} viewBox="-5 -5 37 37" className={className}>
          <circle cx={18.24} cy={17.68} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={10.4} y1={11.08} x2={2.56} y2={4.24} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={-1.472} y1={8.272} x2={5.888} y2={-0.464} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'third-gender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 40" className={className}>
          <circle cx={21.6} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={10.4} y1={16} x2={5.92} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <polygon points="5.92,16 -0.24,12.304 -0.24,19.696" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'hijra':
      return (
        <svg width={size} height={size} viewBox="0 0 32 40" className={className}>
          <line x1={3.68} y1={16} x2={-0.24} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <polygon points="-0.24,16 -5.84,12.64 -5.84,19.36" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path
            d="M 28.32 16 A 12.32 12.32 0 1 0 3.68 16 A 12.32 12.32 0 1 0 28.32 16 M 28.32 16 A 10.08 10.08 0 1 1 5.84 16 A 10.08 10.08 0 1 1 28.32 16 Z"
            fill="currentColor"
          />
        </svg>
      );

    case 'neurogender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 36" className={className}>
          <polygon points="16,4.8 27.2,16 16,27.2 4.8,16" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27.2} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.52} y1={30.56} x2={20.48} y2={30.56} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'detragender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <circle cx={16} cy={16} r={15} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <circle cx={16} cy={10} r={6} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <polygon points="16,18 22,26 16,30 10,26" fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'centrgender':
      return (
        <svg width={size} height={size} viewBox="0 -5 32 40" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={0.8} x2={16} y2={31.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={4.8} x2={16} y2={-3.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.08} y1={0.32} x2={16} y2={-3.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={19.92} y1={0.32} x2={16} y2={-3.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27.2} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.08} y1={31.52} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={19.92} y1={31.52} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={27.2} y1={13.76} x2={30.56} y2={17.12} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={27.2} y1={13.76} x2={23.84} y2={17.12} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={18.24} x2={1.44} y2={14.88} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={18.24} x2={8.16} y2={14.88} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.64} y1={-1.44} x2={16} y2={-1.44} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.64} y1={33.44} x2={19.36} y2={33.44} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'isogender':
      return (
        <svg width={size} height={size} viewBox="0 -5 32 40" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={0.8} x2={16} y2={31.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={13.648} y1={-2.832} x2={18.352} y2={1.872} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={13.648} y1={1.872} x2={18.352} y2={-2.832} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={13.648} y1={29.872} x2={18.352} y2={34.576} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={13.648} y1={34.576} x2={18.352} y2={29.872} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={27.2} y1={13.76} x2={30.56} y2={11.52} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={27.2} y1={13.76} x2={23.84} y2={11.52} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={18.24} x2={1.44} y2={20.48} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={18.24} x2={8.16} y2={20.48} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'ultergender':
      return (
        <svg width={size} height={size} viewBox="0 -5 40 40" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={24.4} y1={8.72} x2={32.8} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={29.168} y1={-1.568} x2={36.432} y2={5.696} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27.2} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.08} y1={30.56} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={19.92} y1={30.56} x2={16} y2={35.04} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'ultergender-equal':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={16} x2={27.2} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={4.8} x2={16} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.84} y1={8.16} x2={31.68} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={27.2} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={31.68} y2={4.8} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27.2} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.52} y1={30.56} x2={20.48} y2={30.56} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={8.16} y1={8.16} x2={0.32} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.32} y1={0.32} x2={4.8} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={0.32} y1={0.32} x2={0.32} y2={4.8} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={6.24} y1={6.24} x2={2.88} y2={9.6} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'questioning':
      return (
        <svg width={size} height={size} viewBox="-8 0 32 20" className={className}>
          <path
            d="M 6.9137 16.5922 C 11.332 16.5922 14.9137 13.0105 14.9137 8.5922 C 14.9137 4.1739 11.332 0.5922 6.9137 0.5922 C 4.5243 0.5922 2.3796 1.6397 0.9137 3.3006 M 6.9137 23.5922 L 7 15 M 3.9137 20.5922 H 9.9137 M 5 5 L 0.7915 3.5118 L 1 -1"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        </svg>
      );

    case 'queer':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <line x1={7.04} y1={4.8} x2={20.48} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={7.04} y1={2.56} x2={1.44} y2={9.92} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={20.48} y1={27.2} x2={26.08} y2={23.28} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={12.48} y1={16} x2={4.8} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'polyamorous':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path
            d="M 16 16.5376 C 27.424 10.1376, 32.128 18.1376, 16 29.4528 C -0.128 18.1376, 4.576 10.1376, 16 16.5376 Z"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
          <path
            d="M 16 20.704 C 8.4736 13.312, 0.6784 17.1136, 0.6784 20.704 C 0.6784 24.2944, 8.4736 28.096, 16 20.704 C 23.5264 13.312, 31.3216 17.1136, 31.3216 20.704 C 31.3216 24.2944, 23.5264 28.096, 16 20.704"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        </svg>
      );

    case 'self-partnering':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path
            d="M 16 16.672 C 27.424 10.272, 32.128 18.272, 16 29.5872 C -0.128 18.272, 4.576 10.272, 16 16.672 Z"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
          <path
            d="M 16 21.376 C 9.5488 14.656, 2.2912 18.4576, 2.2912 21.376 C 2.2912 24.2944, 9.5488 28.096, 16 21.376 C 22.4512 14.656, 29.7088 18.4576, 29.7088 21.376 C 29.7088 24.2944, 22.4512 28.096, 16 21.376"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
          <line x1={2.56} y1={20.032} x2={0.128} y2={22.464} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={2.56} y1={20.032} x2={4.992} y2={22.464} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={29.44} y1={23.872} x2={26.752} y2={21.184} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={29.44} y1={23.872} x2={32.128} y2={21.184} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'nonamorous':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path
            d="M 3.68 13.44 C 8.8 -7.28 11 28 16 28.32 C 21 29 27 17 26 7"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
        </svg>
      );

    case 'ambiamorous':
      return (
        <svg width={size} height={size} viewBox="-10 0 32 32" className={className}>
          <text x={4.8} y={20.8} fontSize="33.6" fontFamily="serif" fill="currentColor" textAnchor="middle">α</text>
        </svg>
      );

    case 'polyflexible':
      return (
        <svg width={size} height={size} viewBox="-5 -5 42 42" className={className}>
          <text x={24} y={0} fontSize="10.08" fontFamily="serif" fill="currentColor" textAnchor="middle">µ</text>
          <text x={10} y={20.8} fontSize="33.6" fontFamily="serif" fill="currentColor" textAnchor="middle">π</text>
        </svg>
      );

    case 'monoflexible':
      return (
        <svg width={size} height={size} viewBox="-5 -5 42 42" className={className}>
          <text x={24} y={0} fontSize="10.08" fontFamily="serif" fill="currentColor" textAnchor="middle">π</text>
          <text x={10} y={20.8} fontSize="28" fontFamily="serif" fill="currentColor" textAnchor="middle">µ</text>
        </svg>
      );

    case 'intersex':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <path
            d="M 8.16 2.56 Q 16 5.92, 23.84 2.56"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
          />
          <line x1={16} y1={27.2} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.52} y1={30.56} x2={20.48} y2={30.56} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'classic-female':
      return (
        <svg width={size} height={size} viewBox="0 -2 32 35" className={className}>
          <circle cx={16} cy={11.52} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={22.72} x2={16} y2={31.68} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.52} y1={27.2} x2={20.48} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'classic-male':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.84} y1={8.16} x2={31.68} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={27.2} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={31.68} y2={4.8} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'male-equal':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={16} x2={27.2} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={4.8} x2={16} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.84} y1={8.16} x2={31.68} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={27.2} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={31.68} y2={4.8} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'female-equal':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={4.8} y1={16} x2={27.2} y2={16} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={4.8} x2={16} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={27.2} x2={16} y2={33.6} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.52} y1={30.56} x2={20.48} y2={30.56} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'demigender':
      return (
        <svg width={size} height={size} viewBox="0 -8 32 40" className={className}>
          <circle cx={16} cy={18.8} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={7.6} x2={16} y2={-2.48} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={-2.48} x2={10.176} y2={1.552} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={-2.48} x2={10.176} y2={-6.512} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'demiboy':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
          <circle cx={16} cy={16} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.84} y1={8.16} x2={31.68} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={27.2} y2={0.32} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={31.68} y1={0.32} x2={31.68} y2={4.8} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'demigirl':
      return (
        <svg width={size} height={size} viewBox="0 0 32 35" className={className}>
          <circle cx={16} cy={14.88} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={16} y1={25.08} x2={16} y2={33.92} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={11.52} y1={29.44} x2={16} y2={29.44} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'intergender':
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={className}>
          <circle cx={16} cy={15.44} r={11.2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={22.16} y1={23.84} x2={28.32} y2={30} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={23.84} y1={21.936} x2={30.56} y2={28.656} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={21.6} y1={31.12} x2={25.52} y2={27.2} stroke="currentColor" strokeWidth={strokeWidth} />
          <line x1={30.56} y1={28.656} x2={30.56} y2={23.136} stroke="currentColor" strokeWidth={strokeWidth} />
        </svg>
      );

    case 'culture-male':
    case 'culture-female':
    case 'immigration-male':
    case 'immigration-female': {
      const previewSize = 32;
      const scaleFactor = 0.72;
      const sx = (previewSize / 56) * scaleFactor;
      const sy = (previewSize / 94) * scaleFactor;
      const rectSide = 54 * sx;
      const centerX = previewSize / 2;
      const rectX = centerX - rectSide / 2;
      const rectY = 39 * sy;
      const stemX = centerX;
      const circleR = 27 * sx;
      const circleCx = centerX;
      const circleCy = rectY + circleR;
      const c = 28;
      const w = 0.9;
      const nx = (x: number) => centerX + ((c + (x - c) * w) * sx - 28 * sx);
      
      const imPath1 = `M ${nx(10.2224)} ${4.20515 * sy} C ${nx(9.20086)} ${12.064 * sy}, ${nx(14.9995)} ${23.187 * sy}, ${nx(27.0779)} ${20.7087 * sy} C ${nx(29.2112)} ${20.2711 * sy}, ${nx(33.1267)} ${17.7128 * sy}, ${nx(34.3581)} ${11.0182 * sy} C ${nx(34.8771)} ${8.19657 * sy}, ${nx(35.7481)} ${5.026 * sy}, ${nx(38.5067)} ${4.23786 * sy} C ${nx(41.2722)} ${3.44775 * sy}, ${nx(44.6243)} ${4.40579 * sy}, ${nx(46.9977)} ${10.4922 * sy}`;
      const imPath2 = `M ${nx(5.99563)} ${10 * sy} C ${nx(4.86028)} ${17.8306 * sy}, ${nx(13.576)} ${29.9694 * sy}, ${nx(27)} ${27.5 * sy} C ${nx(29.3155)} ${27.0741 * sy}, ${nx(34.8406)} ${25.6946 * sy}, ${nx(36.7972)} ${19.7586 * sy} C ${nx(37.7606)} ${16.836 * sy}, ${nx(38.7969)} ${13.3396 * sy}, ${nx(41.869)} ${13.1615 * sy} C ${nx(44.5277)} ${13.0073 * sy}, ${nx(47.1898)} ${14.5562 * sy}, ${nx(47.4988)} ${19.5 * sy}`;
      const twoCurves = shapeType === 'immigration-male' || shapeType === 'immigration-female';
      return (
        <svg width={size} height={size} viewBox="0 0 32 32" className={strokeClass}>
          <path d={`M ${stemX} ${40 * sy} V 0`} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
          {(shapeType === 'culture-male' || shapeType === 'immigration-male') && (
            <rect x={rectX} y={rectY} width={rectSide} height={rectSide} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          )}
          {(shapeType === 'culture-female' || shapeType === 'immigration-female') && (
            <circle cx={circleCx} cy={circleCy} r={circleR} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
          )}
          <path d={imPath1} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
          {twoCurves && <path d={imPath2} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />}
        </svg>
      );
    }
    default:
      return null;
  }
};
